<section class="terminal panel">
  <div class="terminal-head">
    <div>
      <span>Public worker terminal</span>
      <h2>Daily Biometric Work Queue</h2>
    </div>
    <div class="terminal-actions">
      <mat-form-field appearance="outline" subscriptSizing="dynamic">
        <mat-label>Date</mat-label>
        <input matInput [matDatepicker]="terminalDatePicker" [(ngModel)]="dateFilterDate" (dateChange)="loadQueue()" readonly />
        <mat-datepicker-toggle matIconSuffix [for]="terminalDatePicker"></mat-datepicker-toggle>
        <mat-datepicker #terminalDatePicker></mat-datepicker>
      </mat-form-field>
      <button class="btn secondary" type="button" (click)="loadQueue()">Refresh</button>
      <button class="btn" type="button" [disabled]="!selected" (click)="printSelected()">Print</button>
    </div>
  </div>

  <div class="message">{{ message }}</div>
  <div class="error" *ngIf="error">{{ error }}</div>
  <div class="success" *ngIf="success">{{ success }}</div>
  <div class="terminal-skeleton" *ngIf="loading">
    <span></span><span></span><span></span>
  </div>

  <div class="terminal-layout" *ngIf="!loading && queue.length">
    <aside class="queue-list">
      <button
        type="button"
        *ngFor="let item of queue"
        [ngClass]="{ active: selected?._id === item._id, done: item.productionEntry }"
        (click)="select(item)"
      >
        <strong>{{ item.worker?.name }}</strong>
        <span>{{ item.worker?.employeeId }} · {{ statusLabel(item) }}</span>
        <small>{{ formatDate(item.updatedAt) }}</small>
      </button>
    </aside>

    <main class="print-area" *ngIf="selected">
      <div class="terminal-grid">
        <article class="info-card">
          <h3>Worker</h3>
          <dl>
            <dt>Name</dt>
            <dd>{{ selected.worker?.name }}</dd>
            <dt>Employee ID</dt>
            <dd>{{ selected.worker?.employeeId }}</dd>
            <dt>Shift</dt>
            <dd>{{ selected.worker?.shift }}</dd>
            <dt>Status</dt>
            <dd>{{ statusLabel(selected) }}</dd>
          </dl>
        </article>

        <article class="info-card">
          <h3>Assignment</h3>
          <dl>
            <dt>Machine</dt>
            <dd>{{ selected.assignment?.machine?.machineId || 'Not Assigned' }}</dd>
            <dt>Operation</dt>
            <dd>{{ selected.assignment?.operation?.operationName || 'Not Assigned' }}</dd>
            <dt>Material</dt>
            <dd>{{ selected.assignment?.material?.materialNumber || 'Not Assigned' }}</dd>
            <dt>Target</dt>
            <dd>{{ selected.assignment?.quantityToProduce || 'Not Assigned' }}</dd>
          </dl>
        </article>

        <article class="info-card">
          <h3>Punch Details</h3>
          <dl>
            <dt>Check In</dt>
            <dd>{{ formatDate(selected.checkInEvent?.time) }}</dd>
            <dt>Break Out</dt>
            <dd>{{ selected.breakOutEvent?.time ? formatDate(selected.breakOutEvent?.time) : 'Pending' }}</dd>
            <dt>Break In</dt>
            <dd>{{ selected.breakInEvent?.time ? formatDate(selected.breakInEvent?.time) : 'Pending' }}</dd>
            <dt>Check Out</dt>
            <dd>{{ selected.checkOutEvent?.time ? formatDate(selected.checkOutEvent?.time) : 'Pending' }}</dd>
            <dt>Production</dt>
            <dd>{{ selected.productionEntry ? 'Completed' : 'Pending' }}</dd>
          </dl>
        </article>
      </div>

      <div class="workflow-actions" *ngIf="!needsProduction() && !selected.productionEntry && !selected.checkOutEvent">
        <button class="btn secondary" type="button" *ngIf="canBreakOut()" (click)="terminalAction('breakOut')">Break</button>
        <button class="btn secondary" type="button" *ngIf="canBreakIn()" (click)="terminalAction('breakIn')">Break In</button>
        <button class="btn" type="button" *ngIf="canRequestOut()" (click)="terminalAction('requestOut')">Out</button>
      </div>

      <form class="production-form" *ngIf="needsProduction(); else completedState" (ngSubmit)="submitProduction()">
        <h3>Production Entry After Checkout</h3>
        <label>
          Produced Quantity
          <input type="number" min="0" max="1000000" step="1" name="producedQuantity" [(ngModel)]="form.producedQuantity" required />
          <small class="field-error" *ngIf="showProductionFieldError('producedQuantity')">{{ productionFieldError('producedQuantity') }}</small>
        </label>
        <label>
          Rejected Quantity
          <input type="number" min="0" max="1000000" step="1" name="rejectedQuantity" [(ngModel)]="form.rejectedQuantity" required />
          <small class="field-error" *ngIf="showProductionFieldError('rejectedQuantity')">{{ productionFieldError('rejectedQuantity') }}</small>
        </label>
        <label *ngIf="showRejectionReason()">
          Rejection Reason
          <select name="rejectionReason" [(ngModel)]="form.rejectionReason" required>
            <option value="" disabled selected hidden>Select rejection reason</option>
            <option *ngFor="let reason of rejectionReasons" [value]="reason">{{ reason }}</option>
          </select>
          <small class="field-error" *ngIf="showProductionFieldError('rejectionReason')">{{ productionFieldError('rejectionReason') }}</small>
        </label>
        <label>
          Reason
          <textarea name="reason" [(ngModel)]="form.reason" maxlength="300"></textarea>
          <small class="field-error" *ngIf="showProductionFieldError('reason')">{{ productionFieldError('reason') }}</small>
        </label>
        <button class="btn" type="submit">Submit Production</button>
      </form>

      <ng-template #completedState>
        <div class="completed">
          <h3>{{ selected.productionEntry ? 'Production entry completed' : 'Waiting for next punch action' }}</h3>
          <p *ngIf="selected.productionEntry">
            Produced {{ selected.productionEntry.producedQuantity }},
            rejected {{ selected.productionEntry.rejectedQuantity }}.
            {{ selected.productionEntry.rejectionReason || '' }}
          </p>
        </div>
      </ng-template>
    </main>
  </div>

  <div class="empty" *ngIf="!loading && !queue.length">
    <h3>No queue items</h3>
    <p>No assignment found. Please contact supervisor.</p>
  </div>
</section>
